import { api } from '@/core/helpers/axiosHelper';
import { CancelToken } from 'axios';

export default {
   async get({ slot_id, cancel_token, page, per_page }: { slot_id?: number; cancel_token: CancelToken; page: number; per_page: number }) {
      return await api
         .get('/candidate-history', {
            params: {
               'filter[slot_id]': slot_id,
               include:
                  'slot_contract_state,communication.medium_type,communication.communication_delivery_state,user.tenant,slot,squad,time_registration.time_registration_type,time_registration.time_registrationable,slot.performed_hours',
               sort: '-created_at,-id',
               page: page,
               per_page: per_page,
            },
            cancelToken: cancel_token,
         })
         .then((response) => {
            return response.data;
         })
         .catch(() => ({}));
   },
};
